import {Component, OnInit} from '@angular/core';
import {User} from '../../../../common/models/user';
import {AuthService} from '../../../../common/services/auth.service';
import {RestorePasswordModalComponent} from '../restore-password/modal/restore-password-modal.component';
import {MatDialog} from '@angular/material';
import {Utils} from '../../../../common/services/Utils';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../../shared/services/common.service';
import {UserApplicationDialogComponent} from '../user-application-dialog/user-application-dialog.component';
import {Principal} from '../../../../common/services/principal';
import {CommonMainLayoutComponent} from '../common-main-layout/common-main-layout.component';
import {PublicationStatusEnum} from '../../../../common/enums/publication-status.enum';
import {Enroll} from '../../../../common/models/enroll';
import {EnrollApplicationDialogComponent} from '../enroll-enter/enroll-application-dialog/enroll-application-dialog.component';
import {EnrollApplicationService} from '../../services/enroll-application.service';
import {EsuvoOptionService} from '../../../shared/services/esuvo-option.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  userModel = new User('', '');
  private formSubmitAttempt: boolean;
  showRestore = false;
  showUserApplicationLink = false;
  enrollModel = new Enroll(0, '', '');
  canRegister: boolean = false;

  constructor(private dialog: MatDialog,
              private utils: Utils,
              private translateService: TranslateService,
              private commonService: CommonService,
              private _optionsService: EsuvoOptionService,
              private _authService: AuthService,
              private _principal: Principal,
              private commonMainLayoutComponent: CommonMainLayoutComponent,
              private _enrollApplicationService: EnrollApplicationService) {
  }

  ngOnInit() {

    if (!this._principal.isLoggedInFromBackend()) {
      this.commonMainLayoutComponent.initializeAdminPanelLink(true);
    }

    this.commonService.showRestorePassword().subscribe(data => {
      this.showRestore = data;
    });
    this.commonService.showUserApplicationLink().subscribe(data => {
      this.showUserApplicationLink = data;
    });

   this._optionsService.getOptionDto('RECEIVE_ENROLL_ON_ESUOR_BASE').subscribe(data => {
      if (data) {
        this.canRegister = data.booleanValue;
      }
    });
   /* this._enrollApplicationService.canRegister().subscribe(value => {
      this.canRegister = value;
    });*/
  }

  onSubmit(valid) {
    if (!valid) {
      return;
    }
    this.formSubmitAttempt = true;
    this._authService.getEnrollInfo(this.userModel.login).subscribe(data => {
      if (data) {
        this.enrollModel = new Enroll(0, this.userModel.login, this.userModel.password);
        this._authService.loginEnroll(this.enrollModel);
      } else {
        this._authService.login(this.userModel);
      }
    }, error => {
      console.log('this._authService.getEnrollInfo() error:', error);
      this._authService.login(this.userModel);
    });
  }

  restorePassword(): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(RestorePasswordModalComponent, {
      width: '900px',
      height: '350px',
      data: {}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.utils.notifySuccess(this.translateService.instant('saved'), null);
      }
    });
  }

  /*register(): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(UserApplicationDialogComponent, {
      width: '900px',
      height: '600px',
      data: {}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.utils.notifySuccess(this.translateService.instant('saved'), null);
      }
    });
  }*/

  register(): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(EnrollApplicationDialogComponent, {
      width: '1100px',
      height: '750px',
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.utils.notifySuccess(this.translateService.instant('saved'), null);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/login/login.component.ts